import React from 'react';
import { CheckIcon } from 'lucide-react';
const Pricing = () => {
  return <section id="pricing" className="py-16 bg-white" data-id="element-253">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-254">
        <div className="text-center mb-16" data-id="element-255">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-256">料金プラン</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-257">
            明確な料金体系で、追加料金のない安心価格です。必要なサービスに応じてお選びいただけます。
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-258">
          <div className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow" data-id="element-259">
            <div className="bg-blue-50 p-6 border-b border-gray-200" data-id="element-260">
              <h3 className="text-xl font-bold text-gray-900" data-id="element-261">
                ホテル客室清掃
              </h3>
              <div className="mt-4" data-id="element-262">
                <span className="text-4xl font-bold text-gray-900" data-id="element-263">¥3,000</span>
                <span className="text-gray-600 ml-2" data-id="element-264">/ 1時間</span>
              </div>
              <p className="text-gray-600 mt-2" data-id="element-265">2時間からご利用可能</p>
            </div>
            <div className="p-6" data-id="element-266">
              <ul className="space-y-3" data-id="element-267">
                <li className="flex items-start" data-id="element-268">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-269" />
                  <span className="text-gray-700" data-id="element-270">複数客室の連続清掃</span>
                </li>
                <li className="flex items-start" data-id="element-271">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-272" />
                  <span className="text-gray-700" data-id="element-273">ベッドメイキング</span>
                </li>
                <li className="flex items-start" data-id="element-274">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-275" />
                  <span className="text-gray-700" data-id="element-276">バスルーム清掃</span>
                </li>
                <li className="flex items-start" data-id="element-277">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-278" />
                  <span className="text-gray-700" data-id="element-279">アメニティ補充</span>
                </li>
                <li className="flex items-start" data-id="element-280">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-281" />
                  <span className="text-gray-700" data-id="element-282">写真による品質確認</span>
                </li>
              </ul>
              <button className="w-full mt-8 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md" data-id="element-283">
                お申し込み
              </button>
            </div>
          </div>
          <div className="border border-blue-200 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow relative" data-id="element-284">
            <div className="absolute top-0 right-0 bg-blue-600 text-white px-3 py-1 text-sm font-medium rounded-bl-lg" data-id="element-285">
              人気プラン
            </div>
            <div className="bg-blue-50 p-6 border-b border-blue-200" data-id="element-286">
              <h3 className="text-xl font-bold text-gray-900" data-id="element-287">民泊施設清掃</h3>
              <div className="mt-4" data-id="element-288">
                <span className="text-4xl font-bold text-gray-900" data-id="element-289">¥4,000</span>
                <span className="text-gray-600 ml-2" data-id="element-290">/ 時間</span>
              </div>
              <p className="text-gray-600 mt-2" data-id="element-291">2時間からご利用可能</p>
            </div>
            <div className="p-6" data-id="element-292">
              <ul className="space-y-3" data-id="element-293">
                <li className="flex items-start" data-id="element-294">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-295" />
                  <span className="text-gray-700" data-id="element-296">全室の徹底清掃</span>
                </li>
                <li className="flex items-start" data-id="element-297">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-298" />
                  <span className="text-gray-700" data-id="element-299">リネン交換</span>
                </li>
                <li className="flex items-start" data-id="element-300">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-301" />
                  <span className="text-gray-700" data-id="element-302">キッチン・バス清掃消毒</span>
                </li>
                <li className="flex items-start" data-id="element-303">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-304" />
                  <span className="text-gray-700" data-id="element-305">備品の補充・交換</span>
                </li>
                <li className="flex items-start" data-id="element-306">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-307" />
                  <span className="text-gray-700" data-id="element-308">詳細な作業報告書</span>
                </li>
              </ul>
              <button className="w-full mt-8 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md" data-id="element-309">
                お申し込み
              </button>
            </div>
          </div>
          <div className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow" data-id="element-310">
            <div className="bg-blue-50 p-6 border-b border-gray-200" data-id="element-311">
              <h3 className="text-xl font-bold text-gray-900" data-id="element-312">オフィス清掃</h3>
              <div className="mt-4" data-id="element-313">
                <span className="text-4xl font-bold text-gray-900" data-id="element-314">¥3,000</span>
                <span className="text-gray-600 ml-2" data-id="element-315">/ 時間</span>
              </div>
              <p className="text-gray-600 mt-2" data-id="element-316">2時間から承ります</p>
            </div>
            <div className="p-6" data-id="element-317">
              <ul className="space-y-3" data-id="element-318">
                <li className="flex items-start" data-id="element-319">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-320" />
                  <span className="text-gray-700" data-id="element-321">共用部分の清掃</span>
                </li>
                <li className="flex items-start" data-id="element-322">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-323" />
                  <span className="text-gray-700" data-id="element-324">デスク周りの清掃</span>
                </li>
                <li className="flex items-start" data-id="element-325">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-326" />
                  <span className="text-gray-700" data-id="element-327">会議室の準備・清掃</span>
                </li>
                <li className="flex items-start" data-id="element-328">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-329" />
                  <span className="text-gray-700" data-id="element-330">トイレ清掃・消毒</span>
                </li>
                <li className="flex items-start" data-id="element-331">
                  <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5" data-id="element-332" />
                  <span className="text-gray-700" data-id="element-333">ゴミ収集・処理</span>
                </li>
              </ul>
              <button className="w-full mt-8 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md" data-id="element-334">
                お申し込み
              </button>
            </div>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-335">
          <p className="text-gray-600 mb-6" data-id="element-336">
            カスタマイズされたプランをご希望の方は、お気軽にご相談ください。
          </p>
          <a href="#contact" className="inline-flex items-center text-blue-600 font-medium hover:text-blue-800" data-id="element-337">
            お見積りのご依頼
            <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-338">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-339"></path>
            </svg>
          </a>
        </div>
      </div>
    </section>;
};
export default Pricing;